module.exports = __webpack_public_path__ + "static/media/YouTube.3b3bb1c9.svg";